export class ConceptModel {
  conceptId: number = 0;
  typeConceptId: number = 0;
  code: number = 0;
  name: string = '';
  alterCode: string | null = null;
  alterCode2: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
